import type { DriveManagementCopy } from '@/i18n/drives-management-copy-types';

export const zhDriveManagementCopy = {
  description: '面向团队、项目和协作者的共享文件。',
  createDrive: '创建云端硬盘',
  createDriveTitle: '创建共享云端硬盘',
  driveName: '云端硬盘名称',
  driveNameHint: '云端硬盘名称唯一，并会成为易读的文件夹路径。',
  driveNameTaken: '已存在名为“{name}”的云端硬盘。',
  driveNameReserved: '“{name}”是保留名称，请选择其他名称。',
  driveNameInvalid: '云端硬盘名称请使用字母或数字。',
  driveNameSuggestions: '可用：',
  driveDescription: '说明（可选）',
  governance: '云端硬盘用于',
  curatorOptIn: '将我设为资料库管理员',
  workspace: '工作区',
  teamGoverned: '团队',
  projectGoverned: '项目',
  selectTeam: '选择团队',
  selectProject: '选择项目',
  projectVisibility: '项目可见范围',
  assignedMembers: '已分配成员',
  workspaceVisible: '工作区可见',
  customAudience: '自定义受众',
  primaryProjectDrive: '设为项目的主要云端硬盘',
  create: '创建',
  cancel: '取消',
  loading: '正在加载云端硬盘…',
  emptyTitle: '没有可用的云端硬盘',
  emptyDescription: '创建共享云端硬盘，或向管理员申请访问权限。',
  openDrive: '打开云端硬盘',
  settings: '云端硬盘设置',
  members: '成员',
  links: '关联',
  permissions: '权限',
  workflow: '工作流',
  activity: '活动',
  storage: '存储空间',
  role: '角色',
  status: '状态',
  usage: '已用存储空间',
  restrictedFolders: '受限文件夹',
  guestManagement: '访客管理',
  createFailed: '无法创建云端硬盘。',
  addMember: '添加成员',
  removeMember: '移除',
  selectMember: '选择工作区成员',
  noDirectMembers: '尚无直接成员。',
  unknownMember: '未知成员',
  loadMoreMembers: '加载更多成员',
  memberAdded: '已添加成员。',
  memberRemoved: '已移除成员。',
  membersFailed: '无法更新云端硬盘成员。',
  managerOnly: '只有云端硬盘管理员可以管理成员。',
  linkType: '关联类型',
  selectLinkTarget: '选择团队或项目',
  addLink: '添加关联',
  removeLink: '移除',
  noLinks: '此云端硬盘没有团队或项目关联。',
  unknownLink: '上下文不可用',
  linkAdded: '已添加云端硬盘关联。',
  linkRemoved: '已移除云端硬盘关联。',
  linksFailed: '无法更新云端硬盘关联。',
  viewerDownloads: '允许查看者下载',
  publicLinksWorkspacePolicy: '公开链接仍受工作区所有者策略的控制。',
  selectFolder: '选择文件夹',
  restrict: '限制',
  removeRestriction: '移除边界',
  boundaryCreated: '已创建受限文件夹边界。',
  boundaryRemoved: '已移除受限文件夹边界。',
  createWorkflow: '创建默认工作流',
  workflowCreated: '已创建默认工作流。',
  noWorkflows: '此云端硬盘尚未配置工作流。',
  noActivity: '尚无云端硬盘活动。',
  activityAccess: '访问权限已更改',
  activityContent: '内容活动',
  activityWorkflow: '工作流活动',
  activityPublish: '发布活动',
  activityGovernance: '云端硬盘设置已更新',
  activityRecovery: '恢复活动',
  activitySecurity: '安全活动',
  activityAutomation: '智能体活动',
  activityDrive: '云端硬盘已更新',
  policyUpdated: '已更新云端硬盘策略。',
  settingsFailed: '无法更新云端硬盘设置。',
  guestEmail: '访客账号电子邮件',
  addGuest: '添加访客',
  guestAdded: '已将访客添加为评论者。',
  guestFailed: '无法添加此访客。对方必须已有 IMAI 身份。',
  guestExpiry: '访客访问权限默认在 90 天后到期，最高角色为贡献者。',
  recovery: '恢复',
  contentAccessRequired: '需要内容访问权限',
  recoveryDescription: '无需打开或查看云端硬盘内容即可指定替代管理员。',
  replacementManager: '选择替代管理员',
  assignManager: '指定管理员',
  recoveryAssigned: '已指定替代管理员。',
  recoveryFailed: '无法指定替代管理员。',
  publishToLibrary: '发布到工作区云端硬盘',
  publish: '发布',
  publishStarted: '已开始创建受管资料库副本。',
  publishFailed: '无法发布此文件。',
  noPublishableFiles: '此云端硬盘没有可发布的文件。',
  libraryCuratorRequired: '发布需要资料库内容管理员权限。',
} satisfies DriveManagementCopy;

export const zhTwDriveManagementCopy = {
  description: '供團隊、專案和協作者使用的共用檔案。',
  createDrive: '建立雲端硬碟',
  createDriveTitle: '建立共用雲端硬碟',
  driveName: '雲端硬碟名稱',
  driveNameHint: '雲端硬碟名稱唯一，並會成為易讀的資料夾路徑。',
  driveNameTaken: '已有名為「{name}」的雲端硬碟。',
  driveNameReserved: '「{name}」是保留名稱，請選擇其他名稱。',
  driveNameInvalid: '雲端硬碟名稱請使用字母或數字。',
  driveNameSuggestions: '可用：',
  driveDescription: '說明（選填）',
  governance: '雲端硬碟用於',
  curatorOptIn: '將我設為資料庫管理員',
  workspace: '工作區',
  teamGoverned: '團隊',
  projectGoverned: '專案',
  selectTeam: '選取團隊',
  selectProject: '選取專案',
  projectVisibility: '專案可見範圍',
  assignedMembers: '已指派成員',
  workspaceVisible: '工作區可見',
  customAudience: '自訂對象',
  primaryProjectDrive: '設為專案的主要雲端硬碟',
  create: '建立',
  cancel: '取消',
  loading: '正在載入雲端硬碟…',
  emptyTitle: '沒有可用的雲端硬碟',
  emptyDescription: '建立共用雲端硬碟，或向管理員要求存取權。',
  openDrive: '開啟雲端硬碟',
  settings: '雲端硬碟設定',
  members: '成員',
  links: '連結',
  permissions: '權限',
  workflow: '工作流程',
  activity: '活動',
  storage: '儲存空間',
  role: '角色',
  status: '狀態',
  usage: '已用儲存空間',
  restrictedFolders: '受限資料夾',
  guestManagement: '訪客管理',
  createFailed: '無法建立雲端硬碟。',
  addMember: '新增成員',
  removeMember: '移除',
  selectMember: '選取工作區成員',
  noDirectMembers: '尚無直接成員。',
  unknownMember: '未知成員',
  loadMoreMembers: '載入更多成員',
  memberAdded: '已新增成員。',
  memberRemoved: '已移除成員。',
  membersFailed: '無法更新雲端硬碟成員。',
  managerOnly: '只有雲端硬碟管理員可以管理成員。',
  linkType: '連結類型',
  selectLinkTarget: '選取團隊或專案',
  addLink: '新增連結',
  removeLink: '移除',
  noLinks: '此雲端硬碟沒有團隊或專案連結。',
  unknownLink: '無法使用的情境',
  linkAdded: '已新增雲端硬碟連結。',
  linkRemoved: '已移除雲端硬碟連結。',
  linksFailed: '無法更新雲端硬碟連結。',
  viewerDownloads: '允許檢視者下載',
  publicLinksWorkspacePolicy: '公開連結仍受工作區擁有者政策控管。',
  selectFolder: '選取資料夾',
  restrict: '限制',
  removeRestriction: '移除邊界',
  boundaryCreated: '已建立受限資料夾邊界。',
  boundaryRemoved: '已移除受限資料夾邊界。',
  createWorkflow: '建立預設工作流程',
  workflowCreated: '已建立預設工作流程。',
  noWorkflows: '此雲端硬碟尚未設定工作流程。',
  noActivity: '尚無雲端硬碟活動。',
  activityAccess: '存取權限已變更',
  activityContent: '內容活動',
  activityWorkflow: '工作流程活動',
  activityPublish: '發布活動',
  activityGovernance: '雲端硬碟設定已更新',
  activityRecovery: '復原活動',
  activitySecurity: '安全活動',
  activityAutomation: '代理程式活動',
  activityDrive: '雲端硬碟已更新',
  policyUpdated: '已更新雲端硬碟政策。',
  settingsFailed: '無法更新雲端硬碟設定。',
  guestEmail: '訪客帳號電子郵件',
  addGuest: '新增訪客',
  guestAdded: '已將訪客新增為留言者。',
  guestFailed: '無法新增此訪客。對方必須已有 IMAI 身分。',
  guestExpiry: '訪客存取權預設於 90 天後到期，最高角色為協作者。',
  recovery: '復原',
  contentAccessRequired: '需要內容存取權',
  recoveryDescription: '不需開啟或檢視雲端硬碟內容即可指派替代管理員。',
  replacementManager: '選取替代管理員',
  assignManager: '指派管理員',
  recoveryAssigned: '已指派替代管理員。',
  recoveryFailed: '無法指派替代管理員。',
  publishToLibrary: '發佈到工作區雲端硬碟',
  publish: '發佈',
  publishStarted: '已開始建立受管資料庫副本。',
  publishFailed: '無法發佈此檔案。',
  noPublishableFiles: '此雲端硬碟沒有可發佈的檔案。',
  libraryCuratorRequired: '發佈需要資料庫內容管理員權限。',
} satisfies DriveManagementCopy;
